import React, { useRef } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { useDispatch } from "react-redux";
import { createTattoosThunk } from "../../apps/tatoosSlice";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import { tattooSchema } from "../../validations";

const AddTattoo = ({onClose}) => {
    const dispatch = useDispatch();
    const fileInputRef = useRef(null);

    const formik = useFormik({
        initialValues: {
            images: [],
        },
        validationSchema: tattooSchema,
        onSubmit: async (values, { resetForm }) => {
            const formData = new FormData();
            values.images.forEach((image) => {
                formData.append("images", image);
            });

            const response = await dispatch(createTattoosThunk(formData));
            if (response?.payload?.success) {
                toast.success('Tattoo created successfully.');
                if (fileInputRef.current) fileInputRef.current.value = "";
                onClose();
            } else {
                toast.error('Some problem occurred, Please try again.');
            }
        },
    });

    return (
        <div className="container mt-5">
            <form onSubmit={formik.handleSubmit}>
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-body" style={{ maxHeight: "400px", overflowY: "auto" }}>
                            <div className="card shadow-sm p-4 mb-4 w-100">
                                <div className="row g-3">
                                    <div className="col-md-12">
                                        <label className="form-label fw-bold">🖼️ Images</label>
                                        <input
                                            type="file"
                                            accept="image/png, image/jpeg"
                                            ref={fileInputRef}
                                            multiple
                                            onChange={(event) => formik.setFieldValue("images", Array.from(event.currentTarget.files))}
                                        />
                                            {formik.touched.images && formik.errors.images ? (
                                        <span style={{ color: "red" }}>
                                                <div>{formik.errors.images}</div>
                                        </span>
                                            ) : null}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <div className="d-flex justify-content-between w-100">
                                <button type="submit" className="btn btn-primary">✅ Submit</button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    );
};

export default AddTattoo;
